import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import Icon, { IconNameT } from '@/components/common/Icon.tsx'

import { IssueTypeT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'
import { Done } from '@/assets/icons/statusIcons.tsx'

export function createStatusGroupProperty(issueType: IssueTypeT): {
  statusGroupProperty: PopoverProperty
  statuses: PopoverProperty[]
} {
  const statusGroup = issueType?.statusGroup
  const allStatuses = statusGroup?.statuses ?? []

  const statuses: PopoverProperty[] = allStatuses?.map(status => {
    return {
      label: status?.name ?? '',
      value: status['@id'] as string,
      icon: <Icon icon={status.icon as IconNameT} className={`size-4`} />,
      parent: issueType?.statusGroup?.['@id'] ?? '/statuses',
    }
  })

  const statusGroupNestedProperty: PopoverProperty = {
    label: statusGroup?.name ?? '',
    value: issueType?.statusGroup?.['@id'] ?? '/statuses',
    icon: statuses[1]?.icon ?? <Done className={`size-4`} />,
    children: statuses,
  }

  return { statusGroupProperty: statusGroupNestedProperty, statuses }
}
